import {FC, useState} from "react";
import {formatValueAsDate, formatValueAsDateAndTime} from "../../../../helpers/utils/DateUtils";
import InputField from "../../../../components/common/form/InputField";
import {remitDefault} from "../../../../helpers/constants";
import {formatBuyerSellerNames} from "../../../../helpers/utils/Utils";
import {CommentNoteSection} from "./CommentNoteSection";
import {handleRTKQuery} from "../../../../helpers/utils/RtkQueryUtils";
import {useCreateNoteMutation} from "../../productsApi";
import EditorAddEditNoteForm from "../../modal/EditorAddEditNoteForm";


interface SummaryInfoSectionProps {
    orderData: any; // Define proper types for orderData and its items
    certificate: any; // Define proper types for certificate
    setCertificate: React.Dispatch<React.SetStateAction<any>>; // Define the setCertificate function
    orderId: any;
    setIsSavedResult: React.Dispatch<React.SetStateAction<boolean>>;
    deleteNote: any // Adjust if note deletion method is different
    editable: boolean;
    customerOrderNumber: string;
    orderResultModifiedDate: string | null;
    productStatus: string;
    assignTo: string | null;
    showAccount: any;
    setUpdatedAccountIndexList: any; // Adjust the type if it's different
}

const SummaryInfoSection: FC<SummaryInfoSectionProps> = ({
                                                             orderData,
                                                             certificate,
                                                             setCertificate,
                                                             orderId,
                                                             setIsSavedResult,
                                                             deleteNote,
                                                             editable,
                                                             customerOrderNumber,
                                                             orderResultModifiedDate,
                                                             productStatus,
                                                             assignTo,
                                                             showAccount,
                                                             setUpdatedAccountIndexList,
                                                         }) => {
    const [showUpdateNoteModal, setShowUpdateNoteModal] = useState(false);
    const [showAddNoteModal, setShowAddNoteModal] = useState(false);
    const [noteIndex, setNoteIndex] = useState(0);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [noteData, setNoteData] = useState({
        external: false,
        noteBody: "",
        saveAsCanned: false,
        bold: false,
        redColor: false,
        yellowHighlight: false
    });
    const [notesCollapsed, setNotesCollapsed] = useState(() => {
        return !(certificate?.certificateNotes?.length > 0);
    });
    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };
    const toggleNotesCollapse = () => {
        setNotesCollapsed(!notesCollapsed);
    };


    return (
        <>
            <div className="col-span-12 grid grid-cols-12 gap-3 items-center" id="pricingSection0">
                <div className="relative col-span-12 flex items-center gap-5">
                    <div className="w-full">
                        <InputField
                            className=""
                            name="customerOrderNumber"
                            type="text"
                            value={customerOrderNumber}
                            label="Order #"
                            labelPosition="top"
                            disabled
                        />

                    </div>

                    <div className="w-full">
                        <InputField
                            name="customerOrderNumber"
                            type="text"
                            value={String(orderResultModifiedDate ? formatValueAsDateAndTime(orderResultModifiedDate) : "-")}
                            label="Last Saved"
                            labelPosition="top"
                            disabled
                        />
                    </div>
                    <div className="w-full">
                        <InputField
                            name="Date"
                            type="text"
                            value={productStatus}
                            labelPosition="top"
                            label="Product Status"
                            disabled
                        />
                    </div>
                    <div className="w-full">
                        <InputField
                            className={
                                assignTo == null || assignTo === "" ? "bg-warn-2" : ""
                            }
                            name="Date"
                            type="text"
                            value={assignTo == null || assignTo === "" ? "Not assigned" : assignTo}
                            label="Assigned To" labelPosition="top"
                            disabled
                        />
                    </div>
                </div>
            </div>

            <div className="bg-text-1 rounded-[7px] shadow-md pb-2 pt-2 mt-3 col-span-12 grid grid-cols-12 w-full">
                <div className="flex items-center justify-between col-span-12 px-2 py-2">
                    <h5 className="text-lg font-semibold">Summary Information</h5>
                    <button
                        className="text-highlight-5 focus:outline-none"
                        onClick={toggleCollapse}
                    >
                        <i
                            className={`fa fa-angle-right text-right transition-transform duration-300 ${isCollapsed ? "rotate-90" : ""
                                }`}
                            aria-hidden="true"
                        />
                    </button>
                </div>

                {isCollapsed && (
                    <div id="orderInfo" className="col-span-12 py-2 px-2">
                        <hr className="mb-3 text-surface-5"/>

                        <div className="font-semibold flex justify-between w-full bg-highlight-0 text-text-0 px-2 py-1">
                            <div className="w-full pl-2">
                                Issue Date:{" "}
                                {formatValueAsDate(orderData?.data?.originalOrderDate, "MM/DD/YYYY")}
                            </div>
                            <div className="w-full text-center">Order Info</div>
                            <div className="w-full text-right pr-2">
                                Certificate Fee:{" "}
                                {orderData?.data?.totalDisplayPrice != null
                                    ? "$" + orderData.data.totalDisplayPrice.toFixed(2)
                                    : "-"}
                            </div>
                        </div>

                        <div className="col-span-12 grid grid-cols-12 items-center bg-surface-5 ">
                            <div className="col-span-6">

                                <table
                                    className="text-sm w-full [&_td]:border [&_td]:border-b-highlight-0 p-[6px] text-left">
                                    <tbody className="">
                                    <tr className="bg-gray-100">
                                        <td className="p-2 font-medium">Customer</td>
                                        <td className="p-2">
                                            {orderData?.data?.customerDTO?.customerName ?? "-"}
                                        </td>
                                    </tr>
                                    <tr className="bg-gray-100">
                                        <td className="p-2">Branch</td>
                                        <td className=" p-2">
                                            {orderData?.data?.branchDTO?.name ?? "-"}
                                        </td>
                                    </tr>
                                    <tr className="bg-gray-100">
                                        <td className="p-2">Closer</td>
                                        <td className=" p-2">
                                            {orderData?.data?.closingAgent?.fullName ?? "-"}
                                        </td>
                                    </tr>
                                    <tr className="bg-gray-100">
                                        <td className="p-2">GF #</td>
                                        <td className="p-2">
                                            {orderData?.data?.customerOrderNumber ?? "-"}
                                        </td>
                                    </tr>
                                    <tr className="bg-gray-100">
                                        <td className="p-2">Certificate</td>
                                        <td className=" p-2">
                                            {orderData?.data?.tgxId
                                                ? orderData.data.tgxId.substring(11)
                                                : "-"}
                                        </td>
                                    </tr>
                                    <tr className="bg-gray-100">
                                        <td className="p-2">Buyer(s)</td>
                                        <td className="text-right p-2">{formatBuyerSellerNames(orderData?.data?.buyerName)}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-span-6">
                                <table
                                    className="text-sm w-full [&_td]:border [&_td]:border-highlight-0 p-[6px] text-left">
                                    <tbody>
                                    <tr className="">
                                        <td className="p-2 m-[2px] w-1/4">Remitted Address</td>
                                        <td className="text-left p-2 h-[185px] w-[100px]">
                                            {orderData?.data?.customerDTO?.customerType === "RETAIL" ? (
                                                <span>{remitDefault}</span>
                                            ) : (
                                                <InputField
                                                    type="text"
                                                    value={orderData.items?.customerDTO?.remitAddress}
                                                    hideLabel
                                                    placeholder="...."
                                                />
                                            )}
                                        </td>
                                    </tr>
                                    <tr className="bg-gray-100">
                                        <td className="p-2">Seller(s)</td>
                                        <td className="text-right p-2">{formatBuyerSellerNames(orderData?.data?.sellerName)}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className="bg-text-1 rounded-[7px] shadow-md pb-2 pt-2 mt-3 col-span-12 grid grid-cols-12 w-full">
                <div className="flex items-center justify-between col-span-12 px-2 py-2">
                    <h5 className="text-lg font-semibold">Certificate Notes</h5>

                    <button
                        className="text-highlight-5 focus:outline-none"
                        onClick={toggleNotesCollapse}
                    >
                        <i
                            className={`fa fa-angle-right transition-transform duration-300 ${!notesCollapsed ? "rotate-90" : ""
                            }`}
                            aria-hidden="true"
                        />
                    </button>
                </div>

                {!notesCollapsed && (
                    <div
                        id="orderInfo2"
                        className="col-span-12 py-2 px-2"
                    >
                        <hr className="mb-2 text-surface-5"/>

                        <CommentNoteSection
                            type={"Certificate Notes"}
                            curAccount={certificate.certificateNotes}
                            certificate={certificate}
                            setCertificate={setCertificate}
                            orderId={orderId}
                            showAccount={showAccount}
                            setIsSavedResult={setIsSavedResult}
                            deleteNote={deleteNote} editable={editable}
                            setShowAdd={setShowAddNoteModal}
                            setShowUpdate={setShowUpdateNoteModal}
                            noteType={"certificate"}
                            level={true}
                            length={certificate.certificateNotes.length + 1}
                            setIndex={setNoteIndex}
                        />

                    </div>
                )}
            </div>


            {showAddNoteModal &&
                <EditorAddEditNoteForm title={"Add Account Comment"} show={showAddNoteModal}
                                       setShow={setShowAddNoteModal}
                                       index={null}
                                       certificate={certificate}
                                       setCertificate={setCertificate}
                                       orderId={orderId}
                                       showAccount={showAccount}
                                       setIsSavedResult={setIsSavedResult}
                                       level={true}
                                       length={certificate.certificateNotes.length + 1}
                                       setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                />}

            {showUpdateNoteModal &&
                <EditorAddEditNoteForm title={"Update Account Comment"} show={showUpdateNoteModal}
                                       setShow={setShowUpdateNoteModal}
                                       index={noteIndex}
                                       certificate={certificate}
                                       setCertificate={setCertificate} orderId={orderId}
                                       showAccount={showAccount}
                                       setIsSavedResult={setIsSavedResult}
                                       level={true}
                                       setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                />}

        </>
    );
}
export default SummaryInfoSection
